export interface Linkable {
  id: string;
  text: string;
  entityType: string;
}

export class LinkableImpl implements Linkable {

  id: string;
  text: string;
  entityType: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.text = payload.text;
      this.entityType = payload.entityType;
    }
  }

  static createLinkables(result: Array<any>): Linkable[] {
    const linkables = new Array<Linkable>();
    if (result) {
      result.map((item) => {
        linkables.push(new LinkableImpl(item));
      });
    }
    return linkables;
  }

}
